const defaults = {
  system: {
    app_base: `https://${process.env.REACT_APP_STAGE}.${process.env.REACT_APP_DOMAIN}`,
    name: process.env.REACT_APP_NAME,
    IDB_NAME: process.env.REACT_APP_IDB_NAME,
    IDB_STORE: process.env.REACT_APP_IDB_STORE
  },
  s3: {
    REGION: process.env.REACT_APP_REGION,
    BUCKET: `${process.env.REACT_APP_STAGE}-uploads-bucket`
  },
  apiGateway: [
    {
      region: process.env.REACT_APP_REGION,
      endpoint: `https://${process.env.REACT_APP_STAGE}-api.${process.env.REACT_APP_API_BASE}/client`,
      name: "client",
    },
    {
      region: process.env.REACT_APP_REGION,
      endpoint: `https://${process.env.REACT_APP_STAGE}-api.${process.env.REACT_APP_API_BASE}/admin`,
      name: "admin",
    }
  ],
  cognito: {
    REGION: process.env.REACT_APP_REGION,
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID
  },
  crisp: {
    CRISP_SITE_ID: process.env.REACT_APP_CRISP_SITE_ID
  },
  stripe: {
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY
  },
  fasten: {
    REACT_APP_FASTEN_PUBLIC_KEY: process.env.REACT_APP_FASTEN_PUBLIC_KEY
  },
  google: {
    GOOGLE_ANALYTICS_TRACKING_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID,
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    GOOGLE_PICKER_API_KEY: process.env.REACT_APP_GOOGLE_PICKER_API_KEY,
    GOOGLE_PICKER_CLIENT_ID: process.env.REACT_APP_GOOGLE_PICKER_CLIENT_ID
  },
  openai: {
    TTS_URL: process.env.REACT_APP_TTS_ENDPOINT
  }
};

const environments = {
  development: {
    system: {
      app_base: `https://development.eleplan.org`,
      name: "eleplan",
      IDB_NAME: "eleplan-survey-db",
      IDB_STORE: "idb"
    },
    s3: {
      REGION: "us-east-1",
      BUCKET: "development-uploads-bucket"
    },
    apiGateway: [
      {
        region: process.env.REACT_APP_REGION,
        // Local mode hits the gateway at :3100 with NO basePath — the gateway
        // falls everything through to the client lambda port (3200) by default.
        endpoint: !process.env.REACT_APP_LOCAL ? `https://development-api.${process.env.REACT_APP_API_BASE}/client` : "http://localhost:3100",
        name: "client",
      },
      {
        region: process.env.REACT_APP_REGION,
        // Admin endpoint MUST keep its /admin basePath even locally so the
        // gateway can route to the admin lambda port (3201). The gateway then
        // strips the /admin prefix before forwarding, mirroring how API
        // Gateway custom-domain `basePath: admin` works in prod.
        endpoint: !process.env.REACT_APP_LOCAL ? `https://development-api.${process.env.REACT_APP_API_BASE}/admin` : "http://localhost:3100/admin",
        name: "admin",
      }
    ],
    cognito: {
      REGION: "us-east-1",
      USER_POOL_ID: "us-east-1_PolCAHOmW",
      APP_CLIENT_ID: "6frilk7mkvank7esvbudmhgv66",
      IDENTITY_POOL_ID: "us-east-1:9ffc52ef-7f3f-4ca8-b3ea-9acf8926013e"
    },
    crisp: {
      CRISP_SITE_ID: "270b5e86-7525-4648-8655-a30c58306edc"
    },
    stripe: {
      STRIPE_PUBLIC_KEY: "pk_test_51OHDsrAMB6p3TXwRokoqoGcx8mPvWHCZAIMlbSbWBHZI7ez5lnFMdEXfnpxiGoONnjr8mqyKt9aE4W6tcdL3dA2a00rtrNchSH"
    },
    fasten: {
      REACT_APP_FASTEN_PUBLIC_KEY: "public_test_vszbogf55u1xjzcoe6lhpjtuaafzo754pu87p479j71jt"
    },
    google: {
      GOOGLE_ANALYTICS_TRACKING_ID: "G-VLFQT7K5TC",
      FIREBASE_API_KEY: "",
      GOOGLE_PICKER_API_KEY: "AIzaSyCYlA_1ujos2dqYbHuoLKKsdfQE7SCY3Sw",
      GOOGLE_PICKER_CLIENT_ID: "570835884148-nbf6aqd3dj1u6oihdsprn66qve82t80h.apps.googleusercontent.com"
    },
    openai: {
      TTS_URL: "https://hum7ztkaolmu5h5yrfkoxcxbxa0zobud.lambda-url.us-east-1.on.aws"
    }
  },
  production: defaults,
  staging: defaults
};
module.exports = environments[process.env.REACT_APP_STAGE || "development"];